<template>
  <vx-card>
    <h4 class="mb-5">1. Induction</h4>
    <p class="mb-5">
      *Please read this carefully as it is important. Remember this isn’t real - it’s virtual! This
      induction simply acts as a guide for what you might expect in a real life work experience
      setting.
    </p>
    <p class="mb-5">
      Welcome to your software developer work experience induction! Through this work experience,
      you will gain valuable insights into the innovative world of software development.
    </p>
    <p class="mb-5">
      But first, here are some standards that all game developers within our company are required to
      uphold as well as what we will cover.
    </p>

    <h5 class="mb-5">Presentation and behaviour</h5>

    <ol class="numbered-list">
      <li>
        To work collaboratively - to work with, not against one another and to achieve the best
        possible outcomes and company goals
      </li>
      <li>Credit contributions where they are due, never representing another’s work as our own</li>
      <li>
        To treat everyone with respect regardless of race, gender, age, sexuality, family status,
        disability, national origin, and to be alert to the sensitivities of groups and individuals.
      </li>
      <li>To maintain the professional standards of our workplace environment</li>
      <li>Work with integrity</li>
      <li>Follow physical and mental workplace safety guidelines</li>
      <li>Keep up to date with training and learning new skill</li>
      <li>Adhere to agreed schedules and contracts</li>
      <li>
        Represent and communicate our standards outside of your work environment by behaving in a
        respectful and ethical manner
      </li>
    </ol>

    <h5 class="mb-5">You will learn all about</h5>
    <ul class="default-list">
      <li>Coding and programming languages</li>
      <li>Data analysis</li>
      <li>Communication</li>
      <li>Problem solving</li>
    </ul>

    <div class="vx-row mt-10 mb-5">
      <div class="vx-col xl:w-2/3 w-full my-5">
        <responsive-iframe-youtube :src="video.url" :posterimg="video.image" />
      </div>
    </div>

    <h4 class="mb-5">Resources</h4>

    <vs-list>
      <vs-list-item
        title="Induction Sheet"
        subtitle="An overview of what is expected of you and the rules you must follow."
      >
        <vs-button
          color="success"
          type="gradient"
          href="https://www.careertools.com.au/vje/content/nurse/induction_sheet_nursing.pdf"
          target="_blank"
          >Download</vs-button
        >
      </vs-list-item>
    </vs-list>
  </vx-card>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    video() {
      return {
        //url: 'https://www.careertools.com.au/vje/content/' + this.experience.vje.folder_name.toLowerCase() + '/virtual_tour.mp4',
        url: 'https://www.youtube.com/embed/EM1iP3iHhKE',
        image: require('@/assets/images/experiences/' +
          this.experience.vje.folder_name.toLowerCase() +
          '/virtual_tour.jpg'),
      };
    },
  },
};
</script>
